import './App.css';
import TopItems from './TopItems';

function App() {
  return (
    <div className="App">
      <TopItems />
    </div>
  );
}

export default App;
